function AppearOnScroll() {
	barbaCallbacks.push(this);
	this.build();
}

AppearOnScroll.prototype.build = function () {
	const $items = $('[data-aos]');

	if (window.scrollY > 0) {
		$items.each(function (index, elem) {
			$(elem).addClass('appeared');
		});

	} else {
		$(window).on('transitionDone', function () {
			$items.each(function (index, elem) {

				ScrollTrigger.create({
					trigger: elem,
					start: 'top bottom',
					once: true,
					onEnter: function () {
						$(elem).addClass('appeared');
					}
				});

			});
		});
	}

	document.querySelectorAll('[data-aos="splittext"]').forEach(function (elem) {
		let splitText = new SplitText(elem, {
			type: "chars, words"
		});

		splitText.chars.forEach(function (char, index){
			char.style.transitionDelay = 0.01 + index / 50 + 's';
		});
	});

};
